import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { InactivityService } from 'app/modules/shared/services/inactivity.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const inactivityService = inject(InactivityService);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) =>
        {
            // If the user is authenticated...
            if ( authenticated )
            {
                // Put some instructions...
                // Activate inactivity monitoring
                inactivityService.startMonitoring();

            } else {
                // Deactivate inactivity monitoring
                inactivityService.stopMonitoring();

            }

                // Allow the access
                return of(true);
            })
        );
};
